import type { CotacaoDialogProps } from "./types-cotacao-dialog";
import { useCotacaoDialog } from "./use-cotacao-dialog";
import { CotacaoDialogView } from "./view-cotacao-dialog";

export function CotacaoDialog(props: CotacaoDialogProps) {
  const vm = useCotacaoDialog(props);

  return <CotacaoDialogView {...vm} />;
}

export type * from "./types-cotacao-dialog";
